var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShipping = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#15206b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.4077 16.0186c0 .4911-.1951.9622-.5424 1.3095s-.8183.5423-1.3094.5423h-12.03706c-.49114 0-.96225-.195-1.30954-.5423s-.54231-.8184-.54231-1.3095v-12.50005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.63 2.12964h-11.57412c-.36836 0-.72163.14632-.9821.40679-.26047.26046-.40679.61374-.40679.9821 0 .36835.14632.72163.40679.9821s.61374.40679.9821.40679h12.50002c.4911 0 .9621.19513 1.3094.54242s.5424.81829.5424 1.30943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.4072 6.75928v2.77778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.4072 13.2407v2.7778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.556 9.53711h1.8518c.2456 0 .481.09762.6547.27127.1736.17364.2712.40912.2712.65462v1.8519c0 .2456-.0976.4811-.2712.6548-.1737.1736-.4091.2711-.6547.2711h-1.8518c-.4912 0-.9623-.195-1.3096-.5423s-.5423-.8184-.5423-1.3095c0-.4912.195-.9622.5423-1.3095.3473-.34726.8184-.54239 1.3096-.54239z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShipping);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shipping.fa2578663bd8e1d4d6807bfed289f67e.svg";